<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto; height:auto">
      <d-field label="Select A Member">
        <d-autocomplete v-model="selectedUser" :loading="isFetching" icon="search" :data="users" placeholder="Select a user to add..." field="fullName" @typing="getUsersDataAsync">
          <template slot="empty">
            No Users were found
          </template>
          <template v-slot="{option}">
            <p>{{ option.fullName }}</p>
            <p class="text-sm text-gray-600">
              {{ option.systemEmail }}
            </p>
          </template>
        </d-autocomplete>
      </d-field>

      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Add
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
    // TODO: Add Veevalidate to the fields with errorbag support
  import axios from 'axios';
  import debounce from 'lodash/debounce';
  export default {
    props: {
      selectedCommunity: {
        type: Object,
        default: () => { },
      },
    },
    data: () => ({
      saving: false,
      isFetching: false,
      selectedUser: '',
      filter: '',
      users: [],
    }),

    mounted() {
      this.userForm.communityId = this.selectedCommunity.id;
    },

    methods: {
      getUsersDataAsync: debounce(async function (name) {
        if (!name.length) {
          this.users = [];
          return;
        }
        this.isFetching = true;
        try {
          const { data } = await axios.get(`/api/admin/users/paged?currentPage=1&pageSize=20&filter=${name}`);
          this.users = [];
          data.resultItems.forEach((item) => this.users.push(item));
        } catch (error) {
          this.users = [];
          throw error;
        } finally {
          this.isFetching = false;
        }
      }, 500),

      async saveForm() {
        this.saving = true;
        try {
          await axios.post(`/api/admin/communities/${this.selectedCommunity.id}/users/${this.selectedUser}`);
          await this.$parent.events.getCommunityUsers();
          this.$parent.close();
        } catch (error) {
          this.$toast.error(error.response.data);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>